/**
 * @author gyb(mocheer)
 * @since 2016.11.4
 */

import './crs/Proj';
import './crs/Baidu09';
//
import Provider from './Provider';
//
import FeatureLayer from './layer/FeatureLayer';
//
import lonlats from './utils/LonLats';
//
let {
  Action,
  isArray,
  assign: $assign,
  merge
} = T;
let {
  Map,
  Layer,
  Control,
  CRS
} = L;
let {
  Scale
} = Control;
let pluginBaseUrl = 'dmap/leaflet/plugins/';
/**
 * 
 * todo:重构
 */
export default class DMap extends Action {
  /** 
   * 平台名称
   */
  static platform = 'leaflet';
  /**
   * 通用图层类
   */
  static Layer = FeatureLayer;
  /**
   * 
   */
  _layers = [];
  /**
   *  
   */
  map;
  /**
   * 
   */
  provider;
  /**
   * 初始化地图
   * @param options 
   * @param node 
   */
  constructor(node, options) {
    super();
    options = T.assign({
      doubleClickZoom: false,
      zoomControl: false,
      attributionControl: false,
      preferCanvas: true
    }, options);
    options.crs = CRS[options.crs] || options.crs || CRS.EPSG3857; //可以为空，Map初始化时会默认用EPSG3857
    options.center = lonlats(options.center);
    //
    // options.layers = []
    //
    let that = this;
    let map = that.map = new Map(node, options);
    that.el = node;
    that.provider = new Provider().addTo(map);
    if (options.provider) that.provider.addLayers(options);
    options.showCoordinates && that.showCoordinates();
    options.showHawkeyeMap && that.showHawkeyeMap();
    options.showScale && new Scale().addTo(map);
    //
    // options.mask && map.setMask([
    //   [119.3, 26.08]
    // ]);
    //
    that.initHook();
    that._addEvents();
    that._addRenderers();
    //
    that.cursor = 'default';
  }
  /**
   * 二三维一体化，连接
   */
  connect(viewer) {
    let that = this;
    let {
      _layers
    } = that;
    let options = viewer.options;
    //
    // options.provider = that.provider._providerOptions;
    // options.center = that.getCenter();
    // options.zoom = that.getZoom() + 1; //倾斜加1
    // 三维动画
    let copyLayers = () => {
      T.chain(_layers.map(layer => next => {
        layer.connect(viewer.layer());
        setTimeout(next, 300); //此方法延迟并不合适，但临时先这样处理
      }))
      this.on("provider-change", e => {
        let options = this.provider._providerOptions;
        viewer.setProvider(options);
      }).on("layer-add", layer => {
        layer.connect(viewer.layer());
      });
    }
    options.openAnimation ? viewer.on('openAnimation-end', copyLayers) : copyLayers();
    //
    this._connect = viewer;
  }
  /**
   * 
   */
  initHook() {
    ['setView', 'setCenterZoom', 'setExtent', 'zoomBy'].forEach(name => {
      this.addFnHook(name, {
        precall: function () {
          let e = {
            fn: name,
            args: arguments
          };
          if (this._connect && this.suspended) {
            this._connect[e.fn].apply(this._connect, e.args)
          }
        }
      })
    })
  }
  /**
   * 二三维一体化，挂起
   */
  suspend() {
    this.suspended = true;
    T(this.el).visible = false;
  }
  /**
   * 二三维一体化，重启
   */
  resume() {
    this.suspended = false;
    T(this.el).visible = true;
  }
  /**
   * 
   */
  set cursor(options) {
    T(this.el).cursor = options;
  }
  /**
   * 兼容 addTo
   */
  addLayer(layer) {
    let {
      _layers
    } = this;
    if (layer instanceof Layer) {
      this.map.addLayer(layer);
    } else {
      !_layers.includes(layer) && _layers.push(layer);
      this.addLayer(layer.layer);
      this.do('layer-add', layer);
    }
  }
  /**
   * 兼容removeLayer
   * @param {*} layer 
   */
  removeLayer(layer) {
    let {
      _layers
    } = this;
    if (layer instanceof Layer) {
      this.map.removeLayer(layer);
    } else {
      _layers.includes(layer) && _layers.splice(_layers.indexOf(layer), 1);
      this.do('layer-remove', layer);
    }
  }
  /**
   * 
   */
  layer(options) {
    return new FeatureLayer(options).addTo(this);
  }
  // 
  // tile : https://services.arcgisonline.com/ArcGIS/rest/services/USA_Topo_Maps/MapServer
  // export : https://services.arcgisonline.com/arcgis/rest/services/Specialty/Soil_Survey_Map/MapServer
  // featurelayer https://services.arcgis.com/rOo16HdIMeOBI4Mb/arcgis/rest/services/Heritage_Trees_Portland/FeatureServer/0
  esri = fn => {
    if (!this._esriInit) {
      this._esriInit = true;
      let oriFn = fn
      fn = function (esri) {
        let {
          _requestExport
        } = esri.DynamicMapLayer.prototype;
        esri.DynamicMapLayer.include({
          _requestExport(params, bounds) { //wms服务接入
            params = this.options.beforeRequest ? T.assign(params, this.options.beforeRequest.call(this, params)) : params;
            let url = this.options.url;

            if (this.options.isFullPath) {
              this.options.url = url = url[url.length - 1] === '/' ? url.slice(0, url.length - 1) : url;
            }
            //
            if (this.options.f === 'json') {
              this.service.request((this.options.isFullPath ? '' : 'export'), params, function (error, response) {
                if (error) {
                  return;
                } // we really can't do anything here but authenticate or requesterror will fire

                if (this.options.token) {
                  response.href += ('?token=' + this.options.token);
                }
                if (this.options.proxy) {
                  response.href = this.options.proxy + '?' + response.href;
                }
                if (response.href) {
                  this._renderImage(response.href, bounds);
                } else {
                  this._renderImage(response.imageData, bounds, response.contentType);
                }
              }, this);
            } else {
              params.f = 'image';
              this._renderImage(url + (this.options.isFullPath ? '' : 'export') + L.Util.getParamString(params), bounds);
            }
          }
        })
        oriFn.apply(this, arguments);
      }
    }
    T.require([pluginBaseUrl + 'esri-leaflet'], fn)
  }
  /**
   * 
   * @param {*} url 
   * @param {*} options 
   */
  addWMSLayer(url, options) {
    return L.tileLayer.wms(url, options).addTo(this.map);
  }
  /**
   * 设置地图图源
   */
  setProvider(options) {
    let layers = this.provider.updateLayers(options);
    this.do('provider-change');
    return layers;
  }
  /**
   * 
   * @param {*} options 
   */
  addProvider(options) {
    let layers = this.provider.addLayers(options);
    this.do('provider-change');
    return layers;
  }
  /**
   * 设置地图级别
   * @param center
   * @param zoom
   * @param {animate?: boolean,duration?: number,easeLinearity?: number,noMoveStart?: boolean} options
   * 重写
   * 计划用 renderer 动画来实现
   */
  setView(center, zoom, options) {
    if (this._connect && this.suspended) {
      return;
    }
    let {
      map
    } = this;
    let size = 320;
    let timerid = this.timerid = +T.stamp;
    center = lonlats(center);
    //
    this.setCenterZoom(center, zoom, options);
    //
    let rect = this.el.getBoundingClientRect();
    //
    let focalizer = this._focalizer = this._focalizer || T.create('i', 'focalizer dmap dmap-screen', document.body);
    let {
      style
    } = focalizer;
    style.display = '';
    //
    let count = 3;
    let animate = () => {
      if (timerid !== this.timerid) return;
      if ((size -= 12) > 12) {
        let c = map.latLngToContainerPoint(center);
        if (options && options.anchor) {
          c = c.add(options.anchor)
        }
        style.fontSize = size + 'px';
        style.left = (rect.left + c.x - size * 0.5) + 'px';
        style.top = (rect.top + c.y - size * 0.5) + 'px';
        setTimeout(animate, 28);
      } else if (count < 0) {
        style.display = 'none';
      } else {
        size += 48;
        count--;
        setTimeout(animate, 100);
      }
    }
    animate();
  }
  /**
   * 最佳显示视野
   * @param paths 经纬度数组 or path 图元
   * @param options
   */
  setExtent(paths, options) {
    return this.map.fitBounds(isArray(paths) ? lonlats(paths, (isArray(paths[0][0])) ? 2 : 1) : paths instanceof L.LatLngBounds ? paths : paths.getBounds(), options);
  }
  /**
   * 
   * @param {*} center 
   * @param {*} zoom 
   * @param {*} options 
   */
  flyTo(center, zoom, options) {
    this.map.flyTo(lonlats(center), zoom, options)
  }
  /**
   * 移动点图
   * @param point
   */
  panBy(point) {
    this.map.panBy(point);
  }
  /**
   * 
   * @param center 
   * @param zoom 
   */
  setCenterZoom(center, zoom, options) {
    let {
      map
    } = this;
    center = lonlats(center);
    // offset 偏移定位
    if (options && options.offset) {
      if (zoom) {
        map._resetView(this.map.getCenter(), zoom);
        return this.setCenterZoom(center, void 0, options);
      }

      let offset = L.point(options.offset).round();
      center = map.unproject(map.project(center).add(offset));
    }
    //
    if (zoom === void 0) {
      map.panTo(center);
    } else {
      map.setView(center, zoom, options);
    }
  }
  /**
   * 设置层级
   * @param zoom
   */
  setZoom(zoom, options) {
    this.map.setZoom(zoom, options);
  }
  /**
   * 缩放
   */
  zoomBy(delta) {
    this.map.zoomIn(delta);
  }
  /**
   * 获取中心点
   */
  getCenter() {
    return this.map.getCenter();
  }
  /**
   * 获取地图等级
   */
  getZoom() {
    return this.map.getZoom();
  }
  /**
   * 绘制
   * @param {} options 
   */
  draw(options) {
    return new Promise((resolve) => {
      T.require([pluginBaseUrl + 'drawLayer'], drawLayer => {
        resolve((this.tool = this.tool || new(drawLayer.default)().addTo(this)).change(options));
      })
    })
  }
  /**
   * 显示坐标控件
   */
  showCoordinates(options) {
    T.require([pluginBaseUrl + 'widgets'], L => {
      L.coordinates(this, options);
    })
  }
  /**
   * 显示鹰眼图
   */
  showHawkeyeMap(options) {
    T.require([pluginBaseUrl + 'widgets'], L => {
      L.hawkeyeMap(this, options)
    })
  }
  /**
   * 
   */
  _addEvents() {
    let {
      map
    } = this;
    map.on('zoomend moveend', function () {
      let zoom = map.getZoom();
      let bounds = map.getBounds();
      map.eachLayer(layer => {
        if (layer) { // 有可能对Object有属性注入，导致layer为空，甚至为错误的值
          // 
          let tooltip = layer.getTooltip();
          if (tooltip) {
            let {
              options
            } = tooltip;
            if ('zoom' in options) {
              let inZoom = options.zoom <= zoom;
              // 线面数据，暂不支持视野检测
              let toOpen = inZoom && (!layer._latlng || bounds.contains(layer._latlng));
              let isOpen = tooltip.isOpen();
              if (toOpen) {
                !isOpen && !layer._hideTooltip && layer.openTooltip();
              } else {
                map.removeLayer(tooltip);
              }
            }
          }
        }
      });
    })
  }
  /**
   * 
   */
  _addRenderers() {
    let {
      map
    } = this;
    map.__glow = new L.Glow().addTo(map);
    map.__animate = new L.Animate().addTo(map);
    map.__flame = new L.Animate().addTo(map);
  }
  /**
   * 测量距离
   * @param p1 
   * @param p2 
   */
  distance(p1, p2) {
    return this.map.distance(lonlats(p1), lonlats(p2));
  }
  /**
   * 设置区域遮罩层
   */
  setMask(coordinates, options) {
    this.mask && this.mask.remove();
    //   return (this.mask = L.polygon(lonlats(coordinates, isArray(coordinates[0][0]) ? 2 : 1), $assign({
    //   interactive: true,
    //   renderer: new L.Mask((!options || !options.interactive) && {
    //     pane: 'tilePane'
    //   }),
    //   weight: 2,
    //   color: '#042847',
    //   fillOpacity: 1,
    //   fillColor: 'rgba(0,26,51,.7)',
    //   shadowBlur: 5,
    //   shadowColor: '#042847'
    // }, options)).addTo(this.map));
    return (this.mask = L.mask(lonlats(coordinates, isArray(coordinates[0][0]) ? 2 : 1), options).addTo(this.map));
  }
  /**
   * 全屏
   */
  fullScreen() {
    let {
      el
    } = this;
    L.DomUtil[T.fullScreen(el) ? 'addClass' : 'removeClass'](el, 'leaflet-fullscreen-on');
  }
  /**
   * 常用于地图容器宽度高度改变之后。
   */
  resize() {
    this.map.invalidateSize();
  }
  /**
   * 
   * @param {*} point 
   */
  latLngToContainerPoint(point) {
    return this.map.latLngToContainerPoint(point);
  }
  /**
   * 
   * @param {*} point 
   */
  containerPointToLayerPoint(point) {
    return this.map.containerPointToLayerPoint(point);
  }
  /**
   * 
   */
  layerPointToLatLng(point) {
    return this.map.layerPointToLatLng(point);
  }
  /**
   * 
   */
  latLngToLayerPoint(latlng) {
    return this.map.latLngToLayerPoint(latlng);
  }
  /**
   * 
   * @param {*} type 
   * @param {*} fn 
   */
  on(type, fn) {
    type.includes('-') ? super.on(type, fn) : this.map.on(type, fn)
    return this;
  }
  /**
   * 
   * @param {*} type 
   * @param {*} fn 
   */
  off(type, fn) {
    type.includes('-') ? super.off(type, fn) : this.map.off(type, fn)
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/Map.js